module.exports = __webpack_public_path__ + "static/media/dk2048.5219797e.png";